import { memo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import FlatTabbar from 'common-components/FlatTabbar'
import { ReferenceMode } from 'containers/SubSidebar/AIVideoContent/consts'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { TReferenceMode } from 'types/aiVideo'
import FramesSelector from '../FramesSelector'
import * as Styled from './styled'
import MultiRefImagesContent from './MultiRefImagesContent'

const TAB_DATA = [
  { name: ReferenceMode.IMAGES, text: translate(T.IMAGES_LABEL) },
  { name: ReferenceMode.FRAMES, text: translate(T.START_END_FRAME_LABEL) }
]

const TabbedRefContainer = () => {
  const dispatch = useDispatch()
  const referenceMode = useSelector(aiVideoSelectors.referenceMode)

  const handleTabClick = useCallback(
    (name: string) => {
      dispatch(aiVideoThunks.setReferenceMode(name as TReferenceMode))
    },
    [dispatch]
  )

  return (
    <Styled.Container>
      <FlatTabbar
        dataWithTexts={TAB_DATA}
        defaultActiveTabName={referenceMode}
        onCurrentItemClick={handleTabClick}
        height={40}
      />
      <Styled.TabContent>
        {referenceMode === ReferenceMode.IMAGES ? (
          <MultiRefImagesContent />
        ) : (
          <FramesSelector />
        )}
      </Styled.TabContent>
    </Styled.Container>
  )
}

export default memo(TabbedRefContainer)
